import React from 'react';

// Ejemplo simple de conteo por estado procesal
export default function Reportes({ acusados = [], onVolver }) {
  const resumen = acusados.reduce((acc, a) => {
    acc[a.estado_procesal] = (acc[a.estado_procesal] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="container py-4">
      {onVolver && (
        <button className="btn btn-outline-primary btn-volver mb-3" onClick={onVolver}>
          <i className="bi bi-arrow-left"></i>
          <span>Volver</span>
        </button>
      )}
      <h2 className="mb-4">Reportes y Gráficas</h2>
      <div className="row g-4">
        <div className="col-12 col-md-6">
          <div className="card">
            <div className="card-header">Resumen por Estado Procesal</div>
            <div className="card-body">
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between">
                  <span>En investigación</span>
                  <span className="badge bg-primary">{resumen['en_investigacion'] || 0}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>En juicio</span>
                  <span className="badge bg-warning text-dark">{resumen['en_juicio'] || 0}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Sentenciado</span>
                  <span className="badge bg-danger">{resumen['sentenciado'] || 0}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Absuelto</span>
                  <span className="badge bg-success">{resumen['absuelto'] || 0}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Aquí puedes agregar más tarjetas o gráficas usando chart.js o similar */}
      </div>
    </div>
  );
}
